export class TypeMontant {

	public valeur: number;

	public devise: string;

	constructor() {
		this.valeur = null;
		this.devise = '';
	}
}
